import {
  CURRENCY_DEFINITIONS,
  currencyDefinitionByCode,
  DEFAULT_CURRENCY_CODE as SHARED_DEFAULT_CURRENCY_CODE,
  type CurrencyCode as SharedCurrencyCode,
  type CurrencyDefinitionEntry,
} from '@tulasihome/shared';

export type CurrencyCode = SharedCurrencyCode;
export type CurrencyOption = CurrencyDefinitionEntry;

export const SUPPORTED_CURRENCIES: readonly CurrencyOption[] = CURRENCY_DEFINITIONS;

export const SUPPORTED_CURRENCY_CODES: readonly CurrencyCode[] = SUPPORTED_CURRENCIES.map((entry) => entry.code);

export const DEFAULT_CURRENCY_CODE: CurrencyCode = SHARED_DEFAULT_CURRENCY_CODE;

export const currencyOptionByCode: Readonly<Record<CurrencyCode, CurrencyOption>> = currencyDefinitionByCode;
